import React from "react";
import MyStakings from "@/components/Pages/Dashboard/MyStakings";

const StakingPage: React.FC = () => {
  return <MyStakings />;
};
export default StakingPage;
